"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _LogoutDialog = require("../../common/common/Header/components/LogoutDialog");

var _LogoutDialog2 = _interopRequireDefault(_LogoutDialog);

var _actions = require("egov-ui-kit/redux/auth/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import React, { useState } from "react";
// import Snackbar from "@material-ui/core/Snackbar";
// import "./index.css";
// import LogoutDialog from "./components/LogoutDialog";

// export default function SimpleSnackbar({
//   message , logoutPopupOpen
// }) {

//   return (
//     <div className="session-expired-toast">
//       {/* <Snackbar
//         open
//         autoHideDuration={3000}
//         message={message}
//         anchorOrigin={{
//           vertical: "top",
//           horizontal: "center"
//         }}
//       /> */}
//        <LogoutDialog
//           logoutPopupOpen={logoutPopupOpen}
//           closeLogoutDialog={_closeLogoutDialog}
//           logout={_logout}
//           oktext={message}
//           canceltext={"CANCEL"}
//           title={"Logout"}
//           body={"Are you sure you want to logout?"}
//         />
//     </div>
//   );
// }


var SimpleSnackbar = function (_Component) {
  (0, _inherits3.default)(SimpleSnackbar, _Component);

  function SimpleSnackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SimpleSnackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SimpleSnackbar.__proto__ || Object.getPrototypeOf(SimpleSnackbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      logoutPopupOpen: true
    }, _this.closeLogoutDialog = function () {
      _this.setState({
        logoutPopupOpen: false
      });
    }, _this.handleLogout = function () {
      _this.setState({
        logoutPopupOpen: false
      });

      // redux logout action
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SimpleSnackbar, [{
    key: "render",
    value: function render() {
      var logoutPopupOpen = this.state.logoutPopupOpen;
      var message = this.props.message;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_LogoutDialog2.default, {
          logoutPopupOpen: logoutPopupOpen,
          closeLogoutDialog: this.closeLogoutDialog,
          logout: this.handleLogout,
          oktext: "Sign In",
          title: message,
          body: "Your session has expired. Please sign in again"
        })
      );
    }
  }]);
  return SimpleSnackbar;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    message: state.app.notificationToastBar
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { logout: _actions.logout })(SimpleSnackbar);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/NewToast/index.js
// module id = ../lib/egov-ui-kit/components/NewToast/index.js
// module chunks = 504